module.exports = __webpack_public_path__ + "media/images/svg/atelier-2998f594f58a27837d5396845d74f9a7.svg";